import { useTranslation } from "react-i18next";
import usePage from "../../hooks/usePage";
import { Link } from "react-router-dom";
import "./home.sass";
import DOMPurify from "dompurify";
import card01 from "../../assets/images/home/card01.png";
import card02 from "../../assets/images/home/card02.png";
import btn01 from "../../assets/images/home/btn01.png";
import btn02 from "../../assets/images/home/btn02.png";

export default function Home() {
  const { t } = useTranslation();

  usePage({ title: t("homepage.title") });

  return (
    <article className="home">
      <div className="main">
        <div className="home-card">
          <figure className="card-bg">
            <img src={card01} alt="" />
          </figure>
          <h2 className="title">
            <p>{t("homepage.myBear.title")}</p>
          </h2>
          {/* <h3 className="subTitle">{t("homepage.myBear.subTitle")}</h3> */}
          <p
            className="content"
            dangerouslySetInnerHTML={{
              __html: t("homepage.myBear.content"),
            }}
          ></p>
          <Link to="/myBear">
            <div className="btn">
              <figure>
                <img src={btn01} alt="" />
              </figure>
              <div className="btnTxt">{t("homepage.myBear.btnTxt")}</div>
            </div>
          </Link>
        </div>
        <div className="home-card">
          <figure>
            <img src={card02} alt="" />
          </figure>
          <h2 className="title">
            <p>{t("homepage.course.title")}</p>
          </h2>
          {/* <h3 className="subTitle">{t("homepage.course.subTitle")}</h3> */}
          <p
            className="content"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(t("homepage.course.content")),
            }}
          ></p>
          <Link to="/course">
            <div className="btn">
              <figure>
                <img src={btn02} alt="" />
              </figure>
              <div className="btnTxt">{t("homepage.course.btnTxt")}</div>
            </div>
          </Link>
        </div>
      </div>
    </article>
  );
}
